import * as React from "react";
import { CartButton } from "@grandvisionhq/common";
import { FixedCta } from "@grandvisionhq/content";
import { PageLayout } from "@grandvisionhq/layout";
import { useFeatureToggles } from "@grandvisionhq/state";
import { useGetCtaButtonComponent } from "../../hooks/hooks/use-get-cta-button-component.js";
import { CmsComponentSlot } from "../../containers/Slot/containers/Slot/Slot.js";
import { CmsFooter } from "../../containers/Footer/containers/Footer/Footer.js";
import CmsHeader from "../../containers/Header/containers/Header/Header.js";
const defaultLayout = {
  header: true,
  footer: true,
  navigation: true,
  hasOnlyLogoInHeader: false
};
const LAYOUT_SETTINGS_DEFAULT = {};
const CmsPageLayout = ({
  children,
  layoutSettings = LAYOUT_SETTINGS_DEFAULT,
  renderCartButton = defaultRenderCartButton,
  renderWishlistMenuItem,
  hasAlternativeLogo
}) => {
  const layout = { ...defaultLayout, ...layoutSettings };
  const { isWishlistEnabled } = useFeatureToggles();
  const header = layout.header ? /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "header" }, /* @__PURE__ */ React.createElement(
    CmsHeader,
    {
      shouldRenderSiteNav: !layout.hasOnlyLogoInHeader && layout.navigation,
      hasOnlyLogo: layout.hasOnlyLogoInHeader,
      renderCartButton,
      renderWishlistMenuItem: isWishlistEnabled ? renderWishlistMenuItem : void 0
    }
  )) : null;
  const preFooter = layout.footer ? /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "prefooter/shared-container" }) : null;
  const footer = layout.footer ? /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "footer" }, /* @__PURE__ */ React.createElement(CmsFooter, { hasAlternativeLogo })) : null;
  const { contentBlock, color, variant } = useGetCtaButtonComponent();
  const fixedBottomBarContent = contentBlock ? /* @__PURE__ */ React.createElement(
    FixedCta,
    {
      buttonText: contentBlock.buttonText,
      color: color ?? "primary",
      variant: variant ?? "solid",
      newWindow: contentBlock.newWindow,
      icon: contentBlock.iconImage,
      url: contentBlock.url,
      description: contentBlock.description
    }
  ) : null;
  return /* @__PURE__ */ React.createElement(
    PageLayout,
    {
      header,
      footer,
      preFooter,
      fixedBottomBarContent,
      hasSiteNav: layout.navigation,
      hasOnlyLogoInHeader: layout.hasOnlyLogoInHeader
    },
    /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "Xpage container top" }),
    children,
    /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "Xpage container bottom" })
  );
};
function defaultRenderCartButton(item) {
  return /* @__PURE__ */ React.createElement(
    CartButton,
    {
      key: item.label,
      href: item.link && item.link.href,
      label: item.label,
      className: "header-menu__icon"
    }
  );
}
export {
  CmsPageLayout,
  CmsPageLayout as default
};
//# sourceMappingURL=Page.js.map
